'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { startTimer } from '#pplx/frontend/metrics/browser.js';
import { pageTimer, markedModules, PerformanceContext, PagePerformanceContext, } from '#pplx/frontend/metrics/providers/PerformanceProviderShared.js';
import { useMarkTTV as coreUseMarkTTV } from '#pplx/frontend/metrics/useMarkTTV.js';
import { useCallback, useContext, useMemo } from 'react';
export function PerformanceProvider({ children, startTimeFromTimeOriginRef, }) {
    const { markTTV } = coreUseMarkTTV();
    const getPageTimer = useCallback(() => {
        if (pageTimer.startTime !== startTimeFromTimeOriginRef.current) {
            pageTimer.startTime = startTimeFromTimeOriginRef.current;
            pageTimer.timer = startTimer({
                is_first_page: pageTimer.startTime === 0,
            }, {
                nowFromTimeOrigin: startTimeFromTimeOriginRef.current,
            });
        }
        return pageTimer.timer;
    }, [startTimeFromTimeOriginRef]);
    const value = useMemo(() => ({
        markTTV: () => markTTV(startTimeFromTimeOriginRef.current),
        addPageTiming: (name, moreExtra = {}) => getPageTimer().addTiming(name, moreExtra),
        addPageTimingOnce: (name, moreExtra = {}) => getPageTimer().addTimingOnce(name, moreExtra),
        getPageStartTime: () => startTimeFromTimeOriginRef.current,
        getPageTimer: getPageTimer,
    }), [markTTV, startTimeFromTimeOriginRef, getPageTimer]);
    return _jsx(PerformanceContext.Provider, { value: value, children: children });
}
export function PagePerformanceProvider({ children, modules, }) {
    const { markTTV, addPageTimingOnce, getPageStartTime } = useContext(PerformanceContext);
    const pageStartTime = getPageStartTime();
    const markPageTTV = useCallback((module) => {
        if (!modules.includes(module)) {
            // Only mark modules that the page is interested in
            return;
        }
        if (markedModules.startTime !== pageStartTime) {
            markedModules.startTime = pageStartTime;
            markedModules.modules = new Set();
        }
        if (markedModules.modules.has(module)) {
            // If the module has already been marked, the UI is re-mounting
            // for whatever reason and we don't want to mark it again
            return;
        }
        addPageTimingOnce(`web.ttv.${module}`);
        markedModules.modules.add(module);
        // If all modules have been marked, mark the page TTV
        if (modules.every((m) => markedModules.modules.has(m))) {
            markTTV();
        }
    }, [addPageTimingOnce, pageStartTime, modules, markTTV]);
    const value = useMemo(() => ({ markTTV: markPageTTV }), [markPageTTV]);
    return (_jsx(PagePerformanceContext.Provider, { value: value, children: children }));
}
//# sourceMappingURL=PerformanceProvider.js.map